<template>
  <div>
    <div class="clearfix heading-wrapper">
      <div class="col col-12 heading-image">
      </div>
    </div>

    <div class="max-width-4 mx-auto content-wrapper">
      <div class="clearfix mt3">
        <div class="md-col-8 sm-col-12 pr1 mx-auto">
          <div class="clearfix">
            <div class="col-12">
              <h1 class="h1 headline hide">Tracksytems</h1>
              <h2 class="headline">
                Willkommen bei TrackSystems.eu - Dein Ansprechspartner für 4x4 Raupen erweiterung. Wir bieten Umbau Kits für viele verschiedene Fahrzeuge.
              </h2>
              <h2 class="headline" style="color: black;">
                Welcome to TrackSystems.eu your contact for 4x4 track conversions. We offer conversion kits for many different vehicles
              </h2>
            </div>
          </div>

          <div class="col-12">
            <div class="video-container">
              <iframe width="853" height="459" src="https://www.youtube.com/embed/rGEzv16HBd8?rel=0" frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix mt2">
        <div class="md-col-8 sm-col-12 pr1 mx-auto">
          <div class="clearfix">
            <div class="col-12">
              <h3 class="h1 headline">
                Deine Vorteile
              </h3>
            </div>
            <div class="col-12">
              <ul class="pb0 mb0">
                <li class="h4">sehr gutes Preis / Leistung Verhältnis</li>
                <li class="h4">unsere Raupen bieten hohen Fahrkomfort</li>
                <li class="h4">die Raupen sind sehr leise</li>
                <li class="h4">minimaler Wartungsaufwand</li>
                <li class="h4">der Kraftstoffverbrauch ist niedrig</li>
                <li class="h4">unsere Raupen sind sehr wertstabil</li>
                <li class="h4">schnelle Montage</li>
                <li class="h4">keine Umbauarbeiten am Fahrzeug nötig</li>
                <li class="h4">die Raupen sind für den ganzjährigen Betrieb geeignet</li>
                <li class="h4">wir bieten Finanzierungslösungen</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix mt2">
        <div class="md-col-8 sm-col-12 pr1 mx-auto">
          <div class="clearfix">
            <div class="col-12">
              <h3 class="h1 headline">
                Your advantages
              </h3>
            </div>
            <div class="col-12">
              <ul class="pb0 mb0">
                <li class="h4">very good price / performance ratio</li>
                <li class="h4">our tracks are very comfortable to drive</li>
                <li class="h4">the tracks are quiet</li>
                <li class="h4">low maintanance</li>
                <li class="h4">the fuel consumption is low</li>
                <li class="h4">our tracks are very stable in value</li>
                <li class="h4">fast assembly</li>
                <li class="h4">no modification work necessary</li>
                <li class="h4">the tracks are suitable for year-round operation</li>
                <li class="h4">we offer financing</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix mt2">
        <div class="md-col-8 sm-col-12 pr1 mx-auto">
          <div class="clearfix">
            <div class="col-12">
              <h3 class="h1 headline">
                Feedback
              </h3>
            </div>
            <div class="col-12">
              <div class="video-container">
                <iframe width="853" height="459" src="https://www.youtube.com/embed/CC4tarCXe94?rel=0"
                        frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix mt2">
        <div class="col col-12 ">
          <div class="clearfix">
            <div class="max-width-4 mx-auto">
              <div class="clearfix mt2">
                <div class="md-col-8 sm-col-12 mx-auto">
                  <h3 class="headline h1 col-12">
                    Im Einsatz - In use
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-12">
          <div class="clearfix mx-auto">

            <gallery :images="images" :index="index" @close="index = null"></gallery>
            <div
              class="col col-6 md-col-3 gallery-thumb"
              v-for="(image, imageIndex) in images"
              :key="imageIndex"
              @click="index = imageIndex"
            >
              <div class="inner m1 p1" :style="{ backgroundImage: 'url(' + image + ')'}">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix mt2">
        <div class="md-col-8 sm-col-12 pr1 mx-auto">
          <div class="clearfix">
            <div class="col-12">
              <h3 class="h1 headline">
                Kontaktier uns jetzt- Contact us now
              </h3>
            </div>
            <div class="col-12">
              <p class="h3 center">
                <a
                href="tel:+43 (0) 660 828 2238" title="Telefon">+43 (0) 660 828 2238</a> - <a
                href="mailto:pt@tracksystems.eu" title="Email">pt@tracksystems.eu</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix mt2">
        <div class="md-col-8 sm-col-12 pr1 mx-auto">
          <div class="clearfix">
            <div class="col-12">
              <h3 class="h1 headline">
                Weitere Informationen, Fotos und Videos- further information, photos and videos
              </h3>
            </div>
            <div class="col-12 social--links">
              <div class="item inline col">
                <a href="https://www.instagram.com/tracksystems/" rel="nofollow" title="Instagram" class="none">
                  <font-awesome-icon class="icon" :icon="['fab', 'instagram']"/> <span class="text"> Instagram</span>
                </a>
              </div>

              <div class="item inline col">
                <a href="https://www.facebook.com/Raupenlaufwerk/" rel="nofollow" title="Facebook" class="none">
                  <font-awesome-icon class="icon" :icon="['fab', 'facebook']"/> <span class="text"> Facebook</span>
                </a>
              </div>

              <div class="item inline col">
                <a href="https://www.youtube.com/channel/UCmhv20C-QJ4xd8J3B13c7pQ" rel="nofollow" title="Youtube" class="none">
                  <font-awesome-icon class="icon" :icon="['fab', 'youtube']"/> <span  class="text"> Youtube</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix mt2">
        <div class="md-col-8 sm-col-12 pr1 mx-auto">
          <div class="clearfix">
            <div class="col-12">
              <h3 class="h1 headline">
                Fahrszenen/ Driving Scenes
              </h3>
            </div>
            <div class="col-12">
              <div class="video-container">
                <iframe width="853" height="459" src="https://www.youtube.com/embed/qkptrpwXiSE?rel=0"
                        frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="clearfix mt4 footer">
      <div class="col col-12 footer-image">
        <div class="clearfix">
          <div class="max-width-4 mx-auto">
            <div class="clearfix mt4 ">
              <div class="md-col-8 sm-col-12 mx-auto center">
                <ul class="list-style-none list-reset">
                  <li class="h4 p0">
                    <router-link :to="{ name: 'Legal' }" title="Impressum - Tracksystems e.U."
                                 class="text-decoration-none">Impressum
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>import VueGallery from 'vue-gallery'

export default {
  name: 'Home',
  data() {
    return {
      images: [
        'https://cdn.ad-labs.tech/tracksystems/custom/tracksystems-defender-4x4.jpeg',
        'https://cdn.ad-labs.tech/tracksystems/custom/man-truck.jpeg',
        'https://cdn.ad-labs.tech/tracksystems/custom/man-truck-pickup-4x34.jpeg',
        'https://cdn.ad-labs.tech/tracksystems/custom/man-truck-pickup-tracksyystem.jpeg',
        'https://cdn.ad-labs.tech/tracksystems/custom/tracksystems-suzuki.jpeg',
        'https://cdn.ad-labs.tech/tracksystems/custom/tracksystems-suzuki-4x4.jpeg',
        'https://s3.eu-central-1.amazonaws.com/cdn.ad-labs.tech/tracksystems/custom/mitsubishi-tracksystems-pickup.jpeg',
        'https://s3.eu-central-1.amazonaws.com/cdn.ad-labs.tech/tracksystems/custom/mitsubishi-tracksystems.jpeg',
        'https://s3.eu-central-1.amazonaws.com/cdn.ad-labs.tech/tracksystems/custom/trackystems-ford-pickup.jpeg',
        'https://cdn.ad-labs.tech/tracksystems/custom/dacia.jpeg',
        'https://cdn.ad-labs.tech/tracksystems/custom/dacia-tracksystems.jpeg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09349.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09353.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09360.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09362.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09364.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09366.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09367.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09368.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09371.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09373.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09375.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09377.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09386.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09398.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09402.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09406.jpg',
        'https://cdn.ad-labs.tech/tracksystems/ford/TS-09410.jpg'
      ],
      index: null
    }
  },
  components: {
    'gallery': VueGallery
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue